import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root'
})
export class ApijsonService {

  constructor() { }

  public GetHours ()
  {
    return [{
      "HourValue": 1,
      "HourText": "1.00",
      "Selected": false
    }, {
      "HourValue": 2,
      "HourText": "2.00",
      "Selected": false
    }, {
      "HourValue": 3,
      "HourText": "3.00",
      "Selected": false
    }, {
      "HourValue": 4,
      "HourText": "4.00",
      "Selected": false
    }, {
      "HourValue": 5,
      "HourText": "5.00",
      "Selected": false
    }, {
      "HourValue": 6,
      "HourText": "6.00",
      "Selected": false
    }, {
      "HourValue": 7,
      "HourText": "7.00",
      "Selected": false
    }, {
      "HourValue": 8,
      "HourText": "8.00",
      "Selected": false
    }, {
      "HourValue": 9,
      "HourText": "9.00",
      "Selected": false
    }, {
      "HourValue": 10,
      "HourText": "10.00",
      "Selected": false
    }, {
      "HourValue": 11,
      "HourText": "11.00",
      "Selected": false
    }, {
      "HourValue": 12,
      "HourText": "12.00",
      "Selected": false
    }, {
      "HourValue": 13,
      "HourText": "13.00",
      "Selected": false
    }, {
      "HourValue": 14,
      "HourText": "14.00",
      "Selected": false
    }, {
      "HourValue": 15,
      "HourText": "15.00",
      "Selected": false
    }, {
      "HourValue": 16,
      "HourText": "16.00",
      "Selected": false
    }, {
      "HourValue": 17,
      "HourText": "17.00",
      "Selected": false
    }, {
      "HourValue": 18,
      "HourText": "18.00",
      "Selected": false
    }, {
      "HourValue": 19,
      "HourText": "19.00",
      "Selected": false
    }, {
      "HourValue": 20,
      "HourText": "20.00",
      "Selected": false
    }, {
      "HourValue": 21,
      "HourText": "21.00",
      "Selected": false
    }, {
      "HourValue": 22,
      "HourText": "22.00",
      "Selected": false
    }, {
      "HourValue": 23,
      "HourText": "23.00",
      "Selected": false
    }, {
      "HourValue": 0,
      "HourText": "24.00",
      "Selected": false
    },

    ];
  }

  public GetDays () {

    return [{
      'DayID': 0,
      'DayName': 'Sunday'

    }, {
      'DayID': 1,
      'DayName': 'Monday'

    }, {
      'DayID': 2,
      'DayName': 'Tuesday'
    }, {
      'DayID': 3,
      'DayName': 'Wednesday'

    }, {
      'DayID': 4,
      'DayName': 'Thursday'
    }, {
      'DayID': 5,
      'DayName': 'Friday'
    }, {
      'DayID': 6,
      'DayName': 'Saturday'
    },
    ];
  }

  public GetStates() {
    return  [{
      'State': 'AL',
      'StateName': 'AL - ALABAMA'
    }, {
      'State': 'AK',
      'StateName': 'AK - ALASKA'
    }, {
      'State': 'AZ',
      'StateName': 'AZ - ARIZONA'
    }, {
      'State': 'AR',
      'StateName': 'AR - ARKANSAS'
    }, {
      'State': 'CA',
      'StateName': 'CA - CALIFORNIA'
    }, {
      'State': 'CO',
      'StateName': 'CO - COLORADO'
    }, {
      'State': 'CT',
      'StateName': 'CT - CONNECTICUT'
    }, {
      'State': 'DE',
      'StateName': 'DE - DELAWARE'
    }, {
      'State': 'FL',
      'StateName': 'FL - FLORIDA'
    }, {
      'State': 'GA',
      'StateName': 'GA - GEORGIA'
    }, {
      'State': 'HI',
      'StateName': 'HI - HAWAII'
    }, {
      'State': 'ID',
      'StateName': 'ID - IDAHO'
    }, {
      'State': 'IL',
      'StateName': 'IL - ILLINOIS'
    }, {
      'State': 'IN',
      'StateName': 'IN - INDIANA'
    }, {
      'State': 'IA',
      'StateName': 'IA - IOWA'
    }, {
      'State': 'KS',
      'StateName': 'KS - KANSAS'
    }, {
      'State': 'KY',
      'StateName': 'KY - KENTUCKY'
    }, {
      'State': 'LA',
      'StateName': 'LA - LOUISIANA'
    }, {
      'State': 'ME',
      'StateName': 'ME - MAINE'
    }, {
      'State': 'MD',
      'StateName': 'MD - MARYLAND'
    }, {
      'State': 'MA',
      'StateName': 'MA - MASSACHUSETTS'
    }, {
      'State': 'MI',
      'StateName': 'MI - MICHIGAN'
    }, {
      'State': 'MN',
      'StateName': 'MN - MINNESOTA'
    }, {
      'State': 'MS',
      'StateName': 'MS - MISSISSIPPI'
    }, {
      'State': 'MO',
      'StateName': 'MO - MISSOURI'
    }, {
      'State': 'MT',
      'StateName': 'MT - MONTANA'
    }, {
      'State': 'NE',
      'StateName': 'NE - NEBRASKA'
    }, {
      'State': 'NV',
      'StateName': 'NV - NEVADA'
    }, {
      'State': 'NH',
      'StateName': 'NH - NEW HAMPSHIRE'
    }, {
      'State': 'NJ',
      'StateName': 'NJ - NEW JERSEY'
    }, {
      'State': 'NM',
      'StateName': 'NM - NEW MEXICO'
    }, {
      'State': 'NY',
      'StateName': 'NY - NEW YORK'
    }, {
      'State': 'NC',
      'StateName': 'NC - NORTH CAROLINA'
    }, {
      'State': 'ND',
      'StateName': 'ND - NORTH DAKOTA'
    }, {
      'State': 'OH',
      'StateName': 'OH - OHIO'
    }, {
      'State': 'OK',
      'StateName': 'OK - OKLAHOMA'
    }, {
      'State': 'OR',
      'StateName': 'OR - OREGON'
    }, {
      'State': 'PA',
      'StateName': 'PA - PENNSYLVANIA'
    }, {
      'State': 'RI',
      'StateName': 'RI - RHODE ISLAND'
    }, {
      'State': 'SC',
      'StateName': 'SC - SOUTH CAROLINA'
    }, {
      'State': 'SD',
      'StateName': 'SD - SOUTH DAKOTA'
    }, {
      'State': 'TN',
      'StateName': 'TN - TENNESSEE'
    }, {
      'State': 'TX',
      'StateName': 'TX - TEXAS'
    }, {
      'State': 'UT',
      'StateName': 'UT - UTAH'
    }, {
      'State': 'VT',
      'StateName': 'VT - VERMONT'
    }, {
      'State': 'VA',
      'StateName': 'VA - VIRGINIA'
    }, {
      'State': 'WA',
      'StateName': 'WA - WASHINGTON'
    }, {
      'State': 'WV',
      'StateName': 'WV - WEST VIRGINIA'
    }, {
      'State': 'WI',
      'StateName': 'WI - WISCONSIN'
    }, {
      'State': 'WY',
      'StateName': 'WY - WYOMING'
    },
    ]
  }

  public GetPriorityList() {
    return [
      { "Text": "No Weighting score", "Value": "0.00" },
      { "Text": "-2.00", "Value": "-2.00" },
      { "Text": "-1.75", "Value": "-1.75" },
      { "Text": "-1.50", "Value": "-1.50" },
      { "Text": "-1.25", "Value": "-1.25" },
      { "Text": "-1.00", "Value": "-1.00" },
      { "Text": "-0.75", "Value": "-0.75" },
      { "Text": "-0.50", "Value": "-0.50" },
      { "Text": "-0.25", "Value": "-0.25" },
      
      { "Text": "0.25", "Value": "0.25" },
      { "Text": "0.50", "Value": "0.50" },
      { "Text": "0.75", "Value": "0.75"},
      { "Text": "1.00", "Value": "1.00" },
      { "Text": "1.25", "Value": "1.25" },
      { "Text": "1.50", "Value": "1.50" },
      { "Text": "1.75", "Value": "1.75" },
      { "Text": "2.00", "Value": "2.00" }
    ]
  }

  public InitScheduler(){
    return  {
      el: '#app',
      data: {
        counter: 1,
        selected: '',
        hourStart: '',
        hourEnd: '',
        dayStart: '',
        dayEnd: '',
        dayPreStart: '',
        hourPreStart: '',
        dayPreEnd: '',
        hourPreEnd: '',
        elementMove: '',
        dayCheck: {
          isActive: false
        },
        times: [
          {
            hour: '01',
            isActive: false,
            detail:'00:00 am to 00:59 am'
          }, {
            hour: '02',
            isActive: false,
            detail:'01:00 am to 01:59 am'
          }, {
            hour: '03',
            isActive: false,
            detail:'02:00 am to 02:59 am'
          }, {
            hour: '04',
            isActive: false,
            detail:'03:00 am to 03:59 am'
          }, {
            hour: '05',
            isActive: false,
            detail:'04:00 am to 04:59 am'
          }, {
            hour: '06',
            isActive: false,
            detail:'05:00 am to 05:59 am'
          }, {
            hour: '07',
            isActive: false,
            detail:'06:00 am to 06:59 am'

          }, {
            hour: '08',
            isActive: false,
            detail:'07:00 am to 07:59 am'
          }, {
            hour: '09',
            isActive: false,
            detail:'08:00 am to 08:59 am'
          }, {
            hour: '10',
            isActive: false,
            detail:'09:00 am to 09:59 am'
          }, {
            hour: '11',
            isActive: false
            ,detail:'10:00 am to 10:59 am'
          }, {
            hour: '12',
            isActive: false
            ,detail:'11:00 am to 11:59 am'
          }, {
            hour: '13',
            isActive: false,
            detail:'12:00 pm to 12:59 pm'
          }, {
            hour: '14',
            isActive: false,
            detail:'13:00 pm to 13:59 pm'
          }, {
            hour: '15',
            isActive: false,
            detail:'14:00 pm to 14:59 pm'
          }, {
            hour: '16',
            isActive: false,
            detail:'15:00 pm to 15:59 pm'
          }, {
            hour: '17',
            isActive: false,
            detail:'16:00 pm to 16:59 pm'
          }, {
            hour: '18',
            isActive: false,
            detail:'17:00 pm to 17:59 pm'
          }, {
            hour: '19',
            isActive: false,
            detail:'18:00 pm to 18:59 pm'
          }, {
            hour: '20',
            isActive: false,
            detail:'19:00 pm to 19:59 pm'
          }, {
            hour: '21',
            isActive: false,
            detail:'20:00 pm to 20:59 pm'
          }, {
            hour: '22',
            isActive: false,
            detail:'21:00 pm to 21:59 pm'
          }, {
            hour: '23',
            isActive: false,
            detail:'22:00 pm to 22:59 pm'
          },
          {
            hour: '24',
            isActive: false,
            detail:'23:00 pm to 23:59 pm'
          }
        ],
        days: [
        {
            dayName: "Sunday",
            isActive: false,
            dayNumber: 0,
            times: [{
              hour: 1,
              isActive: false,
              BidModifierPercentange: 0
            }, {
              hour: 2,
              isActive: false,
              BidModifierPercentange: 0
            }, {
              hour: 3,
              isActive: false,
              BidModifierPercentange: 0
            }, {
              hour: 4,
              isActive: false,
              BidModifierPercentange: 0
            }, {
              hour: 5,
              isActive: false,
              BidModifierPercentange: 0
            }, {
              hour: 6,
              isActive: false,
              BidModifierPercentange: 0
            }, {
              hour: 7,
              isActive: false,
              BidModifierPercentange: 0
            }, {
              hour: 8,
              isActive: false,
              BidModifierPercentange: 0
            }, {
              hour: 9,
              isActive: false,
              BidModifierPercentange: 0
            }, {
              hour: 10,
              isActive: false
              ,BidModifierPercentange: 0
            }, {
              hour: 11,
              isActive: false,
              BidModifierPercentange: 0
            }, {
              hour: 12,
              isActive: false,
              BidModifierPercentange: 0
            }, {
              hour: 13,
              isActive: false,
              BidModifierPercentange: 0
            }, {
              hour: 14,
              isActive: false,
              BidModifierPercentange: 0
            }, {
              hour: 15,
              isActive: false,
              BidModifierPercentange: 0
            }, {
              hour: 16,
              isActive: false,
              BidModifierPercentange: 0
            }, {
              hour: 17,
              isActive: false,
              BidModifierPercentange: 0
            }, {
              hour: 18,
              isActive: false,
              BidModifierPercentange: 0
            }, {
              hour: 19,
              isActive: false,
              BidModifierPercentange: 0
            }, {
              hour: 20,
              isActive: false,
              BidModifierPercentange: 0
            }, {
              hour: 21,
              isActive: false,
              BidModifierPercentange: 0
            }, {
              hour: 22,
              isActive: false,
              BidModifierPercentange: 0
            }, {
              hour: 23,
              isActive: false,
              BidModifierPercentange: 0
            },
            {
              hour: 24,
              isActive: false,
              BidModifierPercentange: 0
            }

            ]
        },
        {
          dayName: "Monday",
          isActive: false,
          dayNumber: 1,
          times: [
          {
            hour: 1,
            isActive: false,
            BidModifierPercentange: 0
          }, {
            hour: 2,
            isActive: false,
            BidModifierPercentange: 0
          }, {
            hour: 3,
            isActive: false,
            BidModifierPercentange: 0
          }, {
            hour: 4,
            isActive: false,
            BidModifierPercentange: 0
          }, {
            hour: 5,
            isActive: false,
            BidModifierPercentange: 0
          }, {
            hour: 6,
            isActive: false,
            BidModifierPercentange: 0
          }, {
            hour: 7,
            isActive: false,
            BidModifierPercentange: 0
          }, {
            hour: 8,
            isActive: false,
            BidModifierPercentange: 0
          }, {
            hour: 9,
            isActive: false,
            BidModifierPercentange: 0
          }, {
            hour: 10,
            isActive: false,
            BidModifierPercentange: 0
          }, {
            hour: 11,
            isActive: false,
            BidModifierPercentange: 0
          }, {
            hour: 12,
            isActive: false,
            BidModifierPercentange: 0
          }, {
            hour: 13,
            isActive: false,
            BidModifierPercentange: 0
          }, {
            hour: 14,
            isActive: false,
            BidModifierPercentange: 0
          }, {
            hour: 15,
            isActive: false,
            BidModifierPercentange: 0
          }, {
            hour: 16,
            isActive: false,
            BidModifierPercentange: 0
          }, {
            hour: 17,
            isActive: false,
            BidModifierPercentange: 0
          }, {
            hour: 18,
            isActive: false,
            BidModifierPercentange: 0
          }, {
            hour: 19,
            isActive: false,
            BidModifierPercentange: 0
          }, {
            hour: 20,
            isActive: false,
            BidModifierPercentange: 0
          }, {
            hour: 21,
            isActive: false,
            BidModifierPercentange: 0
          }, {
            hour: 22,
            isActive: false,
            BidModifierPercentange: 0
          }, {
            hour: 23,
            isActive: false,
            BidModifierPercentange: 0
          },
          {
              hour: 24,
              isActive: false,
              BidModifierPercentange: 0
          }

          ]
        }, {
          dayName: "Tuesday",
          isActive: false,
          dayNumber: 2,
            times: [{
              hour: 1,
              isActive: false,
              BidModifierPercentange: 0
            }, {
                hour: 2,
                isActive: false,
                BidModifierPercentange: 0
              }, {
                hour: 3,
                isActive: false,
                BidModifierPercentange: 0
              }, {
                hour: 4,
                isActive: false,
                BidModifierPercentange: 0
              }, {
                hour: 5,
                isActive: false,
                BidModifierPercentange: 0
              }, {
                hour: 6,
                isActive: false,
                BidModifierPercentange: 0
              }, {
                hour: 7,
                isActive: false,
                BidModifierPercentange: 0
              }, {
                hour: 8,
                isActive: false,
                BidModifierPercentange: 0
              }, {
                hour: 9,
                isActive: false,
                BidModifierPercentange: 0
              }, {
                hour: 10,
                isActive: false,
                BidModifierPercentange: 0
              }, {
                hour: 11,
                isActive: false,
                BidModifierPercentange: 0
              }, {
                hour: 12,
                isActive: false,
                BidModifierPercentange: 0
              }, {
                hour: 13,
                isActive: false,
                BidModifierPercentange: 0
              }, {
                hour: 14,
                isActive: false,
                BidModifierPercentange: 0
              }, {
                hour: 15,
                isActive: false,
                BidModifierPercentange: 0
              }, {
                hour: 16,
                isActive: false,
                BidModifierPercentange: 0
              }, {
                hour: 17,
                isActive: false,
                BidModifierPercentange: 0
              }, {
                hour: 18,
                isActive: false,
                BidModifierPercentange: 0
              }, {
                hour: 19,
                isActive: false,
                BidModifierPercentange: 0
              }, {
                hour: 20,
                isActive: false,
                BidModifierPercentange: 0
              }, {
                hour: 21,
                isActive: false,
                BidModifierPercentange: 0
              }, {
                hour: 22,
                isActive: false,
                BidModifierPercentange: 0
              }, {
                hour: 23,
                isActive: false,
                BidModifierPercentange: 0
              },
              {
                hour: 24,
                isActive: false,
                BidModifierPercentange: 0
              }

          ]
        }, {
          dayName: "Wednesday",
          isActive: false,
          dayNumber: 3,
            times: [{
              hour: 1,
              isActive: false,
              BidModifierPercentange: 0
            }, {
                hour: 2,
                isActive: false,
                BidModifierPercentange: 0
              }, {
                hour: 3,
                isActive: false,
                BidModifierPercentange: 0
              }, {
                hour: 4,
                isActive: false,
                BidModifierPercentange: 0
              }, {
                hour: 5,
                isActive: false,
                BidModifierPercentange: 0
              }, {
                hour: 6,
                isActive: false,
                BidModifierPercentange: 0
              }, {
                hour: 7,
                isActive: false,
                BidModifierPercentange: 0
              }, {
                hour: 8,
                isActive: false,
                BidModifierPercentange: 0
              }, {
                hour: 9,
                isActive: false,
                BidModifierPercentange: 0
              }, {
                hour: 10,
                isActive: false,
                BidModifierPercentange: 0
              }, {
                hour: 11,
                isActive: false,
                BidModifierPercentange: 0
              }, {
                hour: 12,
                isActive: false,
                BidModifierPercentange: 0
              }, {
                hour: 13,
                isActive: false,
                BidModifierPercentange: 0
              }, {
                hour: 14,
                isActive: false,
                BidModifierPercentange: 0
              }, {
                hour: 15,
                isActive: false,
                BidModifierPercentange: 0
              }, {
                hour: 16,
                isActive: false,
                BidModifierPercentange: 0
              }, {
                hour: 17,
                isActive: false,
                BidModifierPercentange: 0
              }, {
                hour: 18,
                isActive: false,
                BidModifierPercentange: 0
              }, {
                hour: 19,
                isActive: false,
                BidModifierPercentange: 0
              }, {
                hour: 20,
                isActive: false,
                BidModifierPercentange: 0
              }, {
                hour: 21,
                isActive: false,
                BidModifierPercentange: 0
              }, {
                hour: 22,
                isActive: false,
                BidModifierPercentange: 0
              }, {
                hour: 23,
                isActive: false,
                BidModifierPercentange: 0
              },
              {
                hour: 24,
                isActive: false,
                BidModifierPercentange: 0
              }

          ]
        }, {
          dayName: "Thursday",
          isActive: false,
          dayNumber: 4,
            times: [{
              hour: 1,
              isActive: false,
              BidModifierPercentange: 0
            }, {
                hour: 2,
                isActive: false,
                BidModifierPercentange: 0
              }, {
                hour: 3,
                isActive: false,
                BidModifierPercentange: 0
              }, {
                hour: 4,
                isActive: false,
                BidModifierPercentange: 0
              }, {
                hour: 5,
                isActive: false,
                BidModifierPercentange: 0
              }, {
                hour: 6,
                isActive: false,
                BidModifierPercentange: 0
              }, {
                hour: 7,
                isActive: false,
                BidModifierPercentange: 0
              }, {
                hour: 8,
                isActive: false,
                BidModifierPercentange: 0
              }, {
                hour: 9,
                isActive: false,
                BidModifierPercentange: 0
              }, {
                hour: 10,
                isActive: false,
                BidModifierPercentange: 0
              }, {
                hour: 11,
                isActive: false,
                BidModifierPercentange: 0
              }, {
                hour: 12,
                isActive: false,
                BidModifierPercentange: 0
              }, {
                hour: 13,
                isActive: false,
                BidModifierPercentange: 0
              }, {
                hour: 14,
                isActive: false,
                BidModifierPercentange: 0
              }, {
                hour: 15,
                isActive: false,
                BidModifierPercentange: 0
              }, {
                hour: 16,
                isActive: false,
                BidModifierPercentange: 0
              }, {
                hour: 17,
                isActive: false,
                BidModifierPercentange: 0
              }, {
                hour: 18,
                isActive: false,
                BidModifierPercentange: 0
              }, {
                hour: 19,
                isActive: false,
                BidModifierPercentange: 0
              }, {
                hour: 20,
                isActive: false,
                BidModifierPercentange: 0
              }, {
                hour: 21,
                isActive: false,
                BidModifierPercentange: 0
              }, {
                hour: 22,
                isActive: false,
                BidModifierPercentange: 0
              }, {
                hour: 23,
                isActive: false,
                BidModifierPercentange: 0
              },
              {
                hour: 24,
                isActive: false,
                BidModifierPercentange: 0
              }

          ]
        }, {
          dayName: "Friday",
          isActive: false,
          dayNumber: 5,
            times: [{
              hour: 1,
              isActive: false,
              BidModifierPercentange: 0
            }, {
                hour: 2,
                isActive: false,
                BidModifierPercentange: 0
              }, {
                hour: 3,
                isActive: false,
                BidModifierPercentange: 0
              }, {
                hour: 4,
                isActive: false,
                BidModifierPercentange: 0
              }, {
                hour: 5,
                isActive: false,
                BidModifierPercentange: 0
              }, {
                hour: 6,
                isActive: false,
                BidModifierPercentange: 0
              }, {
                hour: 7,
                isActive: false,
                BidModifierPercentange: 0
              }, {
                hour: 8,
                isActive: false,
                BidModifierPercentange: 0
              }, {
                hour: 9,
                isActive: false,
                BidModifierPercentange: 0
              }, {
                hour: 10,
                isActive: false,
                BidModifierPercentange: 0
              }, {
                hour: 11,
                isActive: false,
                BidModifierPercentange: 0
              }, {
                hour: 12,
                isActive: false,
                BidModifierPercentange: 0
              }, {
                hour: 13,
                isActive: false,
                BidModifierPercentange: 0
              }, {
                hour: 14,
                isActive: false,
                BidModifierPercentange: 0
              }, {
                hour: 15,
                isActive: false,
                BidModifierPercentange: 0
              }, {
                hour: 16,
                isActive: false,
                BidModifierPercentange: 0
              }, {
                hour: 17,
                isActive: false,
                BidModifierPercentange: 0
              }, {
                hour: 18,
                isActive: false,
                BidModifierPercentange: 0
              }, {
                hour: 19,
                isActive: false,
                BidModifierPercentange: 0
              }, {
                hour: 20,
                isActive: false,
                BidModifierPercentange: 0
              }, {
                hour: 21,
                isActive: false,
                BidModifierPercentange: 0
              }, {
                hour: 22,
                isActive: false,
                BidModifierPercentange: 0
              }, {
                hour: 23,
                isActive: false,
                BidModifierPercentange: 0
              },
              {
                hour: 24,
                isActive: false,
                BidModifierPercentange: 0
              }

          ]
        }, {
          dayName: "Saturday",
          isActive: false,
          dayNumber: 6,
            times: [{
              hour: 1,
              isActive: false,
              BidModifierPercentange: 0
            }, {
                hour: 2,
                isActive: false,
                BidModifierPercentange: 0
              }, {
                hour: 3,
                isActive: false,
                BidModifierPercentange: 0
              }, {
                hour: 4,
                isActive: false,
                BidModifierPercentange: 0
              }, {
                hour: 5,
                isActive: false,
                BidModifierPercentange: 0
              }, {
                hour: 6,
                isActive: false,
                BidModifierPercentange: 0
              }, {
                hour: 7,
                isActive: false,
                BidModifierPercentange: 0
              }, {
                hour: 8,
                isActive: false,
                BidModifierPercentange: 0
              }, {
                hour: 9,
                isActive: false,
                BidModifierPercentange: 0
              }, {
                hour: 10,
                isActive: false,
                BidModifierPercentange: 0
              }, {
                hour: 11,
                isActive: false,
                BidModifierPercentange: 0
              }, {
                hour: 12,
                isActive: false,
                BidModifierPercentange: 0
              }, {
                hour: 13,
                isActive: false,
                BidModifierPercentange: 0
              }, {
                hour: 14,
                isActive: false,
                BidModifierPercentange: 0
              }, {
                hour: 15,
                isActive: false,
                BidModifierPercentange: 0
              }, {
                hour: 16,
                isActive: false,
                BidModifierPercentange: 0
              }, {
                hour: 17,
                isActive: false,
                BidModifierPercentange: 0
              }, {
                hour: 18,
                isActive: false,
                BidModifierPercentange: 0
              }, {
                hour: 19,
                isActive: false,
                BidModifierPercentange: 0
              }, {
                hour: 20,
                isActive: false,
                BidModifierPercentange: 0
              }, {
                hour: 21,
                isActive: false,
                BidModifierPercentange: 0
              }, {
                hour: 22,
                isActive: false,
                BidModifierPercentange: 0
              }, {
                hour: 23,
                isActive: false,
                BidModifierPercentange: 0
              },
              {
                hour: 24,
                isActive: false,
                BidModifierPercentange: 0
              }

          ]
        },
       ]

      }
    }
  }

  public VerticalIcons() {
    return [
      {
        "VerticalID": 1,
        "Vertical": "Refinance",
        "Icon": "Refinance_001.ico",
        "IconColor": "#fff"
      },
      {
        "VerticalID": 2,
        "Vertical": "Purchase",
        "Icon": "Purchase_001.ico",
        "IconColor": "#fff"
      },
      {
        "VerticalID": 8,
        "Vertical": "Auto Insurance",
        "Icon": "directions_car",
        "IconColor": "#fff"
      },
      {
        "VerticalID": 9,
        "Vertical": "Life Insurance",
        "Icon": "favorite",
        "IconColor": "#fff"
      },
      {
        "VerticalID": 11,
        "Vertical": "Education",
        "Icon": "school",
        "IconColor": "#fff"
      },
      {
        "VerticalID": 13,
        "Vertical": "Health/Medicare",
        "Icon": "local_hospital",
        "IconColor": "#fff"
      },
      {
        "VerticalID": 14,
        "Vertical": "Home Insurance",
        "Icon": "home",
        "IconColor": "#fff"
      },
      {
        "VerticalID": 16,
        "Vertical": "Personal Loans",
        "Icon": "account_balance",
        "IconColor": "#fff"
      },
      {
        "VerticalID": 17,
        "Vertical": "Home Services",
        "Icon": "build",
        "IconColor": "#fff"
      },
      {
        "VerticalID": 18,
        "Vertical": "Pet Insurance",
        "Icon": "pets",
        "IconColor": "#fff"
      }
    ];
}

}
